import { defineStore } from 'pinia';
import { getLocale } from '@didi/gettext';
import { env, ENV_kEYS } from '@/utils';
import { login } from '@/plugins/plugin-sso-login';
import { getApplyRoleList } from '@/pages/overview/service';
import { getAllSideList } from '@/pages/workshop/service';
import { getUserAuthCountry, getUserInfoV1 } from '@/services';
import { gtrCollectTrackCommonData, gtrTrackLogin } from '@/utils/gattaran-track-event';

const storeKey = 'gattaran-workshop-store-app';
const useAppStore = defineStore(storeKey, {
  // 所有数据持久化
  // persist: true,
  // 持久化存储插件其他配置
  persist: [
    {
      // 修改存储中使用的键名称，默认为当前 Store的 id
      key: storeKey,
      // 修改为 sessionStorage，默认为 localStorage
      storage: window.localStorage,
      // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
      paths: ['userInfo', 'sideInfo', 'userAuthCountry'],
      afterRestore: (ctx) => {
        console.log(`--> just restored '${ctx.store.$id}'`);
      },
    },
  ],
  // 推荐使用 完整类型推断的箭头函数
  state: () => {
    return {
      // 用户信息
      userInfo: {}, // 为了组装featureAuth，存store的话性能消耗大，建议从env.get('userInfo')取。
      // getUserAuthCountry
      userAuthCountry: [],
      // 角色列表
      roleList: [],
      // 业务线信息
      sideInfo: [],
      moduleInfo: {},
      // 子应用埋点时间(HTML加载)
      loadTime: {},
      microAppLoading: false,
      // 激活应用信息
      // name: string
      // activeRule: string
      // entry: string
      // appLocation: string|regex[]
      // container: string
      activeMicroAppConfig: null,
      isMobile: false, //  预留
    };
  },
  actions: {
    setIsMobile(data) {
      this.isMobile = data;
    },
    setModuleInfo(data) {
      this.moduleInfo = data;
    },
    setMicroAppLoadingStauts(status) {
      this.microAppLoading = status === 'loading';
    },
    setActiveMicroAppConfig(config) {
      this.activeMicroAppConfig = config;
    },
    async initUserAuthCountry() {
      if (this.userAuthCountry.length) {
        env.set(ENV_kEYS.userAuthCountry, this.userAuthCountry);
        return Promise.resolve(true);
      }
      try {
        this.userAuthCountry = await getUserAuthCountry();
        env.set(ENV_kEYS.userAuthCountry, this.userAuthCountry);
        return true;
      } catch (e) {
        console.warn(e);
        return false;
      }
    },
    async initRoleList() {
      try {
        const list = await getApplyRoleList();
        this.roleList = list || [];
      } catch (e) {
        console.warn(e);
        this.roleList = [];
      }
    },
    async initSidesList() {
      try {
        const list = await getAllSideList();
        this.sideInfo = list || [];
      } catch (e) {
        console.warn(e);
        this.sideInfo = [];
      }
    },
    initUserInfo() {
      // 登录埋点 开始 结束
      const trackData = {
        start() {
          // 缓存登录开始时间
          sessionStorage.setItem('loginStartTime', new Date().getTime());
        },
        end() {
          gtrCollectTrackCommonData({
            request_end_time: new Date().getTime(),
          });
          // 如果缓存里有登录起始时间，说明此次操作是登录成功后的回调
          if (sessionStorage.getItem('loginStartTime')) {
            // 缓存登录完成时间
            gtrTrackLogin({
              loginStartTime: sessionStorage.getItem('loginStartTime'),
              loginReadyTime: new Date().getTime(),
            });
            // 清空缓存内的登录起始时间
            sessionStorage.removeItem('loginStartTime');
          }
        },
      };
      // 登录成功后的回调
      const loginSuccess = (data) => {
        // 存储locale
        if (!data.locale) {
          data.locale = getLocale();
        }
        // 存储用户信息
        this.userInfo = data;
        env.set(ENV_kEYS.userInfo, data);
      };
      // 缓存优化
      if (this.userInfo.id) {
        loginSuccess(this.userInfo);
        trackData.end();
        // 异步获取用户信息，更新缓存
        getUserInfoV1().then((res) => {
          const { errno, data } = res;
          if (+errno === 0 && data) {
            loginSuccess(data);
          }
        });
        return Promise.resolve(this.userInfo);
      }
      return getUserInfoV1().then((res) => {
        const { errno, data } = res;
        if (errno === 10000) {
          trackData.start();
          login(data);
          return Promise.reject(res);
        }
        if (+errno === 0 && data) {
          loginSuccess(data);
          trackData.end();
          return data;
        }
        return Promise.reject(res);
      });
    },
    switchCountry() {
      this.userInfo = {};
    },
  },
});

export default useAppStore;
